import React from "react";
import { PageHero, PageBody } from "./_shared";
import { usePoly } from "./PolyLayout";
import PublicAcademicsPage from "@/components/PublicAcademicsPage";

export default function Academics() {
  const data = usePoly();
  const docs = data.academics || [];
  return (
    <div data-testid="mitest-ac-wrap">
      <PageHero eyebrow="Academic Resources" title="Academics" />
      <PageBody>
        <PublicAcademicsPage docs={docs} theme="yellow" testidPrefix="mitest-ac" />
      </PageBody>
    </div>
  );
}
